import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=7f7549a6&scoped=true&"
import script from "./AddType.vue?vue&type=script&lang=js&"
export * from "./AddType.vue?vue&type=script&lang=js&"
import style0 from "./AddType.vue?vue&type=style&index=0&id=7f7549a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7549a6",
  null
  
)

export default component.exports